import { every } from 'lodash/fp';
import { useSelector } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { PageOrientation } from '@mews-commander/enums';
import { PageSize } from '@mews-commander/data-access';
import { useResolveRoute } from '@mews/routing';
import { isSmallPageSize, notEmpty } from '@mews-commander/utils';
import { getRegistrationCardUrl } from '../selectors';
import HandleButton from '../../../legacy/React/Components/HeadingAction/Handles/HandleButton';
import PrintAction from '../../../legacy/React/Components/HeadingAction/Action/PrintAction';
import { SmallDefaultHandleButton } from '../../../legacy/React/Components/HeadingAction/Handles/HandleIconButton';

interface Props {
    printSize?: PageSize;
    reservationIds: string[];
    text: Mews.TextKey;
    asIconButton?: boolean;
}

const PrintRegistrationCardsButton = ({ text, reservationIds, printSize, asIconButton }: Props) => {
    const resolveRoute = useResolveRoute();
    const url = useSelector((state) => getRegistrationCardUrl(state, { reservationIds, resolveRoute }));

    const pageOrientation =
        printSize != null && isSmallPageSize(printSize) ? PageOrientation.Landscape : PageOrientation.Portrait;

    const action = {
        pageOrientation,
        pageSize: printSize,
        text: asIconButton ? <LocalizedText textKey={text} /> : text,
        url,
    };

    const showButton = every(notEmpty)(action);

    if (showButton) {
        // @ts-expect-error $TSFixMeError: Type '{ action: { pageOrientation: PageOrientation; pageSize: PageSize | undefined; text: string | Element | undefined; ...
        return <PrintAction action={action} component={asIconButton ? SmallDefaultHandleButton : HandleButton} />;
    }
    return null;
};

export default PrintRegistrationCardsButton;
